


































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitalSlaStore, { HospitalSlaModalProps,
  HospitalSlaProps } from '@/components/Suporte/Store/SuporteHospitalSlaStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalSuporteHospitalSla extends Vue {
  @Prop({ type: Boolean, required: true }) readonly showHospitalSla!: boolean
  @Prop({ type: String, required: true }) readonly hospitalSlaNome!: string

  tipoSlaConfigEnum = {
    HoraUtil: 'Hora útil',
    HoraCorrida: 'Hora corrida',
  }

  get getSuporteHospitalSlaStore() {
    return getModule(SuporteHospitalSlaStore, this.$store)
  }

  get hospitalId() {
    return this.getSuporteHospitalSlaStore.hospitalId
  }

  get isHospitalSelected() {
    return !['', null, undefined].includes(this.hospitalId)
  }

  get hospitalSla() {
    return this.getSuporteHospitalSlaStore.hospitalSla
  }

  get hasHospitalSlaConfig() {
    const config = this.getSuporteHospitalSlaStore.hospitalSlaConfig
    return config && config.id
  }

  get hospitalSlaConfigTable() {
    return [
      { text: 'Hora início', sortable: false, align: 'center' },
      { text: 'Hora fim', sortable: false, align: 'center' },
      { text: 'Tipo', sortable: false, align: 'center' },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  get hospitalSlaTable() {
    return [
      { text: 'Situação solicitação', sortable: false },
      {
        text: 'Quantidade horas critério normal',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Quantidade horas critério alerta',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Caráter',
        sortable: false,
        align: 'center',
      },
      { text: 'Possui OPME', sortable: false, align: 'center' },
      { text: 'Ações', value: '', align: 'center', sortable: false },
    ]
  }

  caraterTitle(carater?: HospitalSlaProps["carater"]): string {
    if (!carater) return "-"
    const caraterTitlesEnum: Record<NonNullable<HospitalSlaProps["carater"]>, string> = {
      Urgencia: "Urgência",
      EletivoAutorizacao: "Eletivo",
      EletivoSemAutorizacao: "Eletivo Sem Autorização"
    }
    return caraterTitlesEnum[carater]
  }

  openModal(target: HospitalSlaModalProps) {
    this.getSuporteHospitalSlaStore.setModal({ isOpen: true, target })
  }

  closeModal() {
    this.$emit('onClose')
  }

  editSlaConfig() {
    this.getSuporteHospitalSlaStore.setNewHospitalSlaConfig({
      ...this.getSuporteHospitalSlaStore.hospitalSlaConfig,
    })
    this.openModal('EDIT_SLA_CONFIG')
  }

  async getSolicitacaoSituacoes() {
    if (this.getSuporteHospitalSlaStore.solicitacaoSituacoes.length === 0) {
      EventBus.$emit('setLoadingRequest', {
        status: true,
        text: 'Carregando...',
      })
      await this.getSuporteHospitalSlaStore.getSolicitacaoSituacoes()
      EventBus.$emit('clearLoadingRequest')
    }
  }

  async addHospitalSla() {
    await this.getSolicitacaoSituacoes()
    this.openModal('REGISTER_SLA')
  }

  async editHospitalSla(item: HospitalSlaProps) {
    await this.getSolicitacaoSituacoes()
    this.getSuporteHospitalSlaStore.setNewHospitalSla({ ...item })
    this.openModal('EDIT_SLA')
  }

  async deleteHospitalSla(item: HospitalSlaProps) {
    await this.getSolicitacaoSituacoes()
    this.getSuporteHospitalSlaStore.setNewHospitalSla(item)
    this.openModal('DELETE')
  }
}
